module.exports = __webpack_public_path__ + "img/uid-token-game-guide-kr.10f77b56.png";